import { createSelector } from 'reselect'
import { PARENT_DEVICE } from 'constants'
import { selectCurrentPhoneId } from '../App/selectors'

const selectTopic = (state) => state.helpfulTopics

const selectTopics = createSelector(selectTopic, (topics) => topics.topics)

const selectTopicsFetching = createSelector(
  selectTopic,
  (topics) => topics.isFetching
)

const selectDeviceId = createSelector(
  selectCurrentPhoneId,
  (phoneId) => phoneId || PARENT_DEVICE
)
export { selectTopics, selectTopicsFetching, selectDeviceId }
